import { memo } from 'react';
import { BlockStack, Button, Card, Text } from '@shopify/polaris';

export interface HelpCenterCardProps {
  icon: JSX.Element;
  title: string;
  description: string;
  url?: string;
  onClick?: () => void;
  // TR-480: card được nhấn mạnh (tile "1:1 Strategy Call") → viền xanh #006fff theo Figma node 1208-7593.
  highlighted?: boolean;
}

const HelpCenterCard = ({ title, icon, description, url, onClick, highlighted }: HelpCenterCardProps) => {
  return (
    <div style={highlighted ? { border: '1px solid #006fff', borderRadius: 'var(--p-border-radius-300, 12px)' } : undefined}>
      <Card>
        <BlockStack gap="200">
          <Text as="h6" variant="headingSm" alignment="center">
            {icon}
          </Text>
          <Button size="large" variant="plain" url={url} onClick={onClick}>
            {title}
          </Button>
          <Text as="p" variant="bodySm" alignment="center">
            {description}
          </Text>
        </BlockStack>
      </Card>
    </div>
  );
};

export default memo(HelpCenterCard);
